module.exports = __webpack_public_path__ + "img/chevron.3be45025.svg";